/*
  rg-interactions.js — Grove
  "App-like" micro-interactions, layered on top of Dawn (no core files forked):
    1. page-ready fade-in
    2. hover-tilt on premium cards (fine pointer only)
    3. fly-to-cart ghost + cart-icon bounce on Add to Cart
    4. sticky Add-to-Cart bar on the product page (appears once the buy
       buttons scroll out of view; proxies the real submit so gating/variant
       logic is untouched)
  All effects are progressive enhancement and honour prefers-reduced-motion.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---------- helpers: haptics + toasts ---------- */
  function haptic(ms) {
    if (navigator.vibrate) { try { navigator.vibrate(ms || 10); } catch (e) {} }
  }
  function toast(msg) {
    var wrap = document.querySelector('.rg-toasts');
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'rg-toasts'; document.body.appendChild(wrap); }
    var t = document.createElement('div');
    t.className = 'rg-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span class="rg-toast__tick" aria-hidden="true">&#10003;</span><span>' + msg + '</span>';
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 320);
    }, 2600);
  }
  function pulse(el) {
    if (!el || reduce) return;
    el.classList.remove('rg-pulse'); void el.offsetWidth; el.classList.add('rg-pulse');
  }

  /* ---------- 1. page-ready fade-in ---------- */
  requestAnimationFrame(function () {
    document.documentElement.classList.add('rg-ready');
  });

  /* ---------- 2. hover tilt on premium cards ---------- */
  if (!reduce && fine) {
    document.querySelectorAll('.rg-tier, .rg-cmp__card').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform =
          'perspective(1000px) rotateY(' + (px * 4).toFixed(2) + 'deg) rotateX(' +
          (-py * 4).toFixed(2) + 'deg)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- 3. fly-to-cart + cart bounce ---------- */
  function cartIcon() {
    return document.querySelector('#cart-icon-bubble') ||
           document.querySelector('.header__icon--cart');
  }
  function bounceCart() {
    var c = cartIcon();
    if (!c || reduce) return;
    c.classList.remove('rg-cart-bounce');
    void c.offsetWidth; // restart animation
    c.classList.add('rg-cart-bounce');
  }
  function flyToCart(sourceImg) {
    var target = cartIcon();
    if (reduce || !sourceImg || !target) { bounceCart(); return; }
    var s = sourceImg.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    if (!s.width) { bounceCart(); return; }
    var ghost = sourceImg.cloneNode(true);
    ghost.className = 'rg-fly';
    ghost.removeAttribute('loading');
    ghost.style.left = s.left + 'px';
    ghost.style.top = s.top + 'px';
    ghost.style.width = s.width + 'px';
    ghost.style.height = s.height + 'px';
    document.body.appendChild(ghost);
    requestAnimationFrame(function () {
      var tx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var ty = (t.top + t.height / 2) - (s.top + s.height / 2);
      ghost.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(0.08)';
      ghost.style.opacity = '0.15';
      ghost.style.borderRadius = '50%';
    });
    setTimeout(function () { ghost.remove(); bounceCart(); }, 760);
  }

  var pendingAdd = 0;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit');
    if (!btn || btn.disabled || btn.classList.contains('rg-atc-gated')) return;
    haptic(14);
    pendingAdd = Date.now();
    var img = document.querySelector(
      '.product__media img, .product__media-item img, .product-media img, .rg-pdp-ph__img'
    );
    setTimeout(function () { flyToCart(img); }, 0);
  }, true);

  /* ---------- 5. optimistic "Added ✓" + toast on successful add ---------- */
  function onAddSuccess() {
    if (Date.now() - pendingAdd > 4000) return; // only react to a recent click
    pendingAdd = 0;
    haptic([10, 40, 10]);
    toast('Added to your cart');
    // flash "Added ✓" on the product submit button
    var span = document.querySelector('product-form .product-form__submit > span');
    if (span && !span.dataset.rgBusy) {
      span.dataset.rgBusy = '1';
      var original = span.textContent;
      span.textContent = 'Added ✓';
      span.closest('.product-form__submit').classList.add('rg-added');
      setTimeout(function () {
        span.textContent = original;
        span.closest('.product-form__submit').classList.remove('rg-added');
        delete span.dataset.rgBusy;
      }, 1600);
    }
    // pulse the cart subtotal once the drawer re-renders
    setTimeout(function () {
      pulse(document.querySelector('.totals__subtotal-value, .totals .price, cart-drawer .totals__total-value'));
    }, 360);
  }

  // Watch the header cart for count changes (covers first add, where the bubble is created)
  var cartLink = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
  if (cartLink && window.MutationObserver) {
    new MutationObserver(function () { onAddSuccess(); })
      .observe(cartLink, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- cart drawer: honest made-to-order reassurance line ---------- */
  function injectDrawerNote() {
    var footer = document.querySelector('cart-drawer .drawer__footer, .cart-drawer .drawer__footer');
    if (!footer || footer.querySelector('.rg-drawer-note')) return;
    var note = document.createElement('p');
    note.className = 'rg-drawer-note';
    note.innerHTML = '<span class="rg-drawer-note__dot" aria-hidden="true"></span>Made to order by hand in our UK workshop.';
    footer.insertBefore(note, footer.firstChild);
  }
  var drawerEl = document.querySelector('cart-drawer, .cart-drawer');
  if (drawerEl && window.MutationObserver) {
    injectDrawerNote();
    new MutationObserver(injectDrawerNote).observe(drawerEl, { childList: true, subtree: true });
  }

  /* ---------- 6b. image fade-in (skeleton-lite) ---------- */
  document.querySelectorAll('.product__media-item img, .card__media img, .rg-cmp__img, .rg-story__img').forEach(function (img) {
    if (img.complete && img.naturalWidth) { img.classList.add('rg-img-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('rg-img-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('rg-img-loaded'); }, { once: true });
  });

  /* ---------- haptic on configurator / variant selection ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.closest('.rg-swatch, .rg-tile, .product-form__input')) haptic(8);
  });

  /* ---------- rating (under title) → smooth scroll to the reviews block ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#rg-all-reviews"]');
    if (!link) return;
    var target = document.getElementById('rg-all-reviews');
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#rg-all-reviews');
  });

  /* ---------- 4. sticky Add-to-Cart on the product page ---------- */
  function initStickyBuy() {
    var realSubmit = document.querySelector('product-form .product-form__submit');
    if (!realSubmit) return;
    var titleEl = document.querySelector('.product__title h1') ||
                  document.querySelector('h1.product__title') ||
                  document.querySelector('.product__title');

    var bar = document.createElement('div');
    bar.className = 'rg-stickybuy';
    bar.innerHTML =
      '<div class="rg-stickybuy__inner page-width">' +
        '<img class="rg-stickybuy__thumb" alt="" width="50" height="50" hidden>' +
        '<div class="rg-stickybuy__info">' +
          '<span class="rg-stickybuy__title"></span>' +
          '<span class="rg-stickybuy__variant" hidden></span>' +
        '</div>' +
        '<span class="rg-stickybuy__price"></span>' +
        '<button type="button" class="button rg-stickybuy__btn">Add to cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    if (titleEl) bar.querySelector('.rg-stickybuy__title').textContent = titleEl.textContent.trim();
    var priceOut = bar.querySelector('.rg-stickybuy__price');
    var thumbOut = bar.querySelector('.rg-stickybuy__thumb');
    var variantOut = bar.querySelector('.rg-stickybuy__variant');

    function syncPrice() {
      var p = document.querySelector('.product__info-container .price');
      if (!p) return;
      priceOut.innerHTML = p.innerHTML;
      // Strip Dawn's Sale / Sold-out badge spans: outside the .price wrapper's
      // state classes they'd otherwise always show in the sticky bar, falsely
      // reading "Sale" / "Sold out" when the variant is neither.
      var badges = priceOut.querySelectorAll('.price__badge-sale, .price__badge-sold-out, .badge, .price__badges');
      for (var i = 0; i < badges.length; i++) {
        if (badges[i].parentNode) badges[i].parentNode.removeChild(badges[i]);
      }
    }

    // The currently-DISPLAYED gallery image — reflects finish + leg filtering
    // (the gallery filter hides non-matching slides), so the thumb tracks the
    // actual desk the customer has configured, not just the variant image.
    function currentGalleryImg() {
      var list = document.querySelector('.product__media-list');
      if (!list) return null;
      return (
        list.querySelector('.product__media-item.is-active:not(.hidden) img') ||
        list.querySelector('.product__media-item:not(.hidden) img')
      );
    }

    // Build "180cm × 80cm · Tobacco Finish · Black A-frame Legs" from the live
    // selections: Width/Depth are options[] <select>s, Finish is the checked
    // swatch radio, legs are the line-item property inputs.
    function variantString() {
      var width = '';
      var depth = '';
      document
        .querySelectorAll('variant-selects select[name^="options["]')
        .forEach(function (sel) {
          var m = sel.name.match(/options\[(.*)\]/);
          var name = (m ? m[1] : '').toLowerCase();
          var opt = sel.options[sel.selectedIndex];
          var val = (opt ? opt.value : sel.value || '').trim();
          if (name.indexOf('width') !== -1) width = val;
          else if (name.indexOf('depth') !== -1) depth = val;
        });

      var finish = '';
      var fChecked = document.querySelector('.rg-finish-swatches input:checked');
      if (fChecked) finish = (fChecked.value || '').trim();
      if (!finish) {
        var fSpan = document.querySelector('.rg-finish-fieldset [data-selected-value]');
        if (fSpan) finish = fSpan.textContent.trim();
      }

      var legStyle = (document.querySelector('[name="properties[Leg style]"]') || {}).value || '';
      var legColour = (document.querySelector('[name="properties[Leg colour]"]') || {}).value || '';

      var parts = [];
      var size = [width, depth].filter(Boolean).join(' × ');
      if (size) parts.push(size);
      if (finish) parts.push(finish + ' Finish');
      var legs = [legColour.trim(), legStyle.trim()].filter(Boolean).join(' ');
      if (legs) parts.push(legs + ' Legs');
      return parts.join(' · ');
    }

    function syncMeta() {
      var img = currentGalleryImg();
      if (img) {
        var src = img.currentSrc || img.src;
        // 50px thumb: always request a small CDN variant. img.src is the full
        // 1946px fallback URL and currentSrc is empty until the gallery image
        // has loaded, so this was silently downloading ~200KB per page view.
        if (src) src = src.replace(/([?&]width=)\d+/, '$1120');
        if (src && thumbOut.src !== src) thumbOut.src = src;
        if (src) thumbOut.hidden = false;
        if (img.alt) thumbOut.alt = img.alt;
      }
      var str = variantString();
      variantOut.textContent = str;
      variantOut.hidden = !str;
    }

    var rafQueued = false;
    function refresh() {
      rafQueued = false;
      syncPrice();
      syncMeta();
    }
    function schedule() {
      if (rafQueued) return;
      rafQueued = true;
      requestAnimationFrame(refresh);
    }
    refresh();

    // Re-sync on any selection change, and whenever the gallery or info column
    // re-renders (Dawn swaps variant-selects + price; the gallery filter swaps
    // the visible slide). Debounced to one update per frame.
    document.addEventListener('change', schedule);
    if (window.MutationObserver) {
      ['.product__media-list', '.product__info-container'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) {
          new MutationObserver(schedule).observe(el, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
          });
        }
      });
    }

    bar.querySelector('.rg-stickybuy__btn').addEventListener('click', function () {
      realSubmit.click(); // proxy — keeps Dawn's variant + our gating logic intact
    });

    var anchor = document.querySelector('.product-form__buttons') || realSubmit;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      // show once the real buy buttons have scrolled up out of view
      bar.classList.toggle('is-visible', rect.bottom < 8);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBuy);
  } else {
    initStickyBuy();
  }
})();
